<template>
    <el-dialog
        :visible="visible"
        :modal-append-to-body="false"
        :close-on-click-modal="true"
        class="ah-detail-dialog loan-draw-dialog gray-bg"
        top="4vh"
        append-to-body
        :before-close="() => onClose()"
        @open="onOpen"
    >
        <template slot="title" v-if="data">
            <span>動撥明細</span>
            <span class="sno">{{ data.systemNo }}</span>
        </template>
        <div>
            <div class="detail-card" v-if="data">
                <div style="font-weight: bold; color: #463cb2">
                    <span v-if="data.repaymentWay === 1">循環額度</span>
                    <span v-if="data.repaymentWay === 2">平均攤還</span>
                    <span v-if="data.isMakeUpRegistration">（補登）</span>
                </div>
                <h3 class="detail-title" style="font-size: 14pt; margin-bottom: 20px">{{ data.summary }}</h3>
                <div class="spec-list" style="max-width: 250px">
                    <div class="item">
                        <span class="field">動撥日期：</span>
                        <span class="value">{{ data.drawdownDate | dateFormater("YYYY / MM / dd") }}</span>
                    </div>
                    <div class="item">
                        <span class="field">存入銀行帳戶：</span>
                        <span class="value">{{ data.depositorBankName || "(無)" }}</span>
                    </div>
                </div>
                <el-row :gutter="20">
                    <el-col :sm="6">
                        <div class="ah-card">
                            <div class="content" style="padding-left: 0">
                                <div class="statis-title">動撥金額</div>
                                <div class="statis-num">
                                    <Money :v="data.amount" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="6">
                        <div class="ah-card">
                            <div class="content">
                                <div class="statis-title">已還款總額<ah-tip>不含預約還款</ah-tip></div>
                                <div class="statis-num">
                                    <Money :v="returnTotalTilToday" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :sm="12">
                        <div class="ah-card">
                            <div class="content">
                                <div class="statis-title">未還總額</div>
                                <div class="statis-num">
                                    <Money :v="data.amount - returnTotalTilToday" />
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
                <div v-if="data && data.repaymentWay == 2" style="padding: 5px 0">
                    <div style="font-size: 11pt; padding-bottom: 5px">
                        <span>還款進度：</span>
                        <span>{{ getPercentage() }}%</span>
                    </div>
                    <el-progress :percentage="getPercentage()" :show-text="false" :color="getPercentage() === 100 ? '#92DE56' : '#463cb2'" :stroke-width="7"></el-progress>
                </div>
            </div>
        </div>
        <div>
            <div class="detail-card">
                <div style="display: flex; justify-content: space-between; align-items: center">
                    <h3 class="">還款明細 <span v-if="data && data.repaymentList.length > 0">（共 {{ data.repaymentList.length }} 筆）</span></h3>
                    <div>
                        <el-button @click="onExport">匯出Excel</el-button>
                        <el-button v-if="!viewMode && !isQR()" type="primary" @click="onAddReturn(data)" icon="el-icon-plus">還款</el-button>
                    </div>
                </div>
                <hr />

                <el-table
                    v-if="data"
                    :data="data.repaymentList"
                    style="width: 100%"
                    class="ah-el-data-table"
                    :summary-method="getReturnTableSummaries"
                    show-summary
                    :default-sort="{ prop: 'repaymentDate', order: 'descending' }"
                    size="small"
                >
                    <el-table-column label="#" type="index"></el-table-column>
                    <el-table-column prop="repaymentDate" label="還款日期" width="110" sortable>
                        <template slot-scope="scope">
                            <div>
                                <span>{{ scope.row.repaymentDate | dateFormater("YYYY-MM-dd") }}</span>
                                <span v-if="isReserve(scope.row.repaymentDate)" class="reserved"><i class="el-icon-time" /> 預約</span>
                            </div>
                            <!-- <div style="font-size: 9pt; color: #aaa;">{{ scope.row.systemNo }}</div> -->
                        </template>
                    </el-table-column>
                    <el-table-column prop="principalAmount" label="還款本金" align="right" width="120">
                        <template slot-scope="scope">
                            <Money :v="scope.row.principalAmount" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="interestAmount" label="還利息" align="right" min-width="70">
                        <template slot-scope="scope">
                            <Money :v="scope.row.interestAmount" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalAmount" label="扣款總額" align="right" width="120">
                        <template slot-scope="scope">
                            <Money :v="scope.row.totalAmount" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalAmount" label="借款餘額" align="right" width="120">
                        <template slot-scope="scope">
                            <Money :v="scope.row.balance" />
                        </template>
                    </el-table-column>
                    <el-table-column prop="repaymentBankName" label="扣款銀行帳戶" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.repaymentBankName }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="note" label="備註">
                        <template slot-scope="scope">
                            {{ scope.row.note }}
                        </template>
                    </el-table-column>
                    <el-table-column v-if="!viewMode && !isQR()" align="center" width="80">
                        <template slot-scope="scope">
                            <!-- <el-button size="small" @click="onEditReturn(scope.row)">編輯</el-button> -->
                            <el-dropdown trigger="click" @command="onRepaymentDropdownClick">
                                <span class="el-dropdown-link">
                                    <el-button size="mini" icon="el-icon-more"></el-button>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item :command="{ action: 'edit', repayment: scope.row }">編輯</el-dropdown-item>
                                    <el-dropdown-item :command="{ action: 'delete', repayment: scope.row }">刪除</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <AccountingInfoBlock
                :sno="{ drawdownSno: data.sno }"
                :qty="data.voU_COUNT"
                :status="data.vocherStatus"
                :queryType="8"
                :voucher-status-updater="data.voucherStatusUpdateName"
                :voucher-status-update-date="data.voucherStatusUpdateDate"
                @refresh="() => reload()"
            />
        </div>
        <div class="detail-row footer between" v-if="data">
            <div v-if="!viewMode && !isQR()" style="display: flex">
                <el-tooltip v-if="data.repaymentList && data.repaymentList.length > 0" class="item" effect="dark" content="有還款記錄無法刪除，如欲刪除請先移除還款。" placement="top">
                    <div style="display: inline-block; margin-right: 10px">
                        <el-button icon="el-icon-delete" :disabled="true">刪除</el-button>
                    </div>
                </el-tooltip>
                <el-button v-else :loading="isLoading" @click="onDelete" icon="el-icon-delete"> 刪除 </el-button>
                <el-button @click="onEditDrawRequest(data)" icon="el-icon-edit">編輯動撥</el-button>
            </div>
            <el-button @click="onClose">關閉</el-button>
        </div>
    </el-dialog>
</template>

<script>
import _ from 'lodash';
import moment from 'moment';
import RepaymentExcelMixins from './RepaymentExcelMixins';

export default {
    mixins: [RepaymentExcelMixins],
    components: {
        AccountingInfoBlock: () => import('@/components/ui/AccountingInfoBlock.vue'),
    },
    props: {
        visible: Boolean,
        viewMode: Boolean,
        sno: {
            type: Number,
            default: null,
        },
        drawdown: {
            type: Object,
            default: () => {},
        },
        contrast: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            isLoading: false,
            data: {
                repaymentDate: null,
                principalAmount: 0,
                interestAmount: 0,
                totalAmount: 0,
                repaymentBankSno: null,
                repaymentList: [],
                isSystemGenerated: undefined,
                note: null,
                reM_FEE_AMT: 0,
                reM_FEE_PAY_DAT: null,
                reM_FEE_BNK_SNO: null,
                vocherStatus: null,
            },

            creator: null,
            createDate: null,
            editor: null,
            editDate: null,
            activeTab: 'returnList',
            isReturnDeleted: false,
        };
    },
    watch: {
        data(newValue, oldValue) {
            console.log('newValue', newValue);
        },
    },
    computed: {
        returnTotal() {
            if (!this.data) return null;
            return this.data.repaymentList.reduce((a, b) => a.principalAmount + b.principalAmount);
        },
        returnTotalTilToday() {
            return _.chain(_.filter(this.data.repaymentList, (x) => x.repaymentDate <= +new Date()))
                .sumBy('principalAmount')
                .value();
        },
        creatorInfo() {
            if (!this.form.crT_NAM || !this.form.crT_DAT) return false;

            return `${this.form.crT_NAM || '--'}, ${moment(this.form.crT_DAT).format('YYYY-MM-DD') || '--'}`;
        },
        editorInfo() {
            if (!this.form.upD_NAM || !this.form.upD_DAT) return false;

            return `${this.form.upD_NAM || '--'}, ${moment(this.form.upD_DAT).format('YYYY-MM-DD') || '--'}`;
        },
        isAmortization() {
            return this.drawdown?.repaymentWay === 2;
        },
        drawdownInfo() {
            return `${this.drawdown?.systemNo} ${this.drawdown?.summary}`;
        },
    },
    methods: {
        getReturnTableSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            sums[1] = '還款總金額';
            sums[2] = _.sumBy(data, 'principalAmount').toLocaleString('en');
            sums[3] = _.sumBy(data, 'interestAmount').toLocaleString('en');
            sums[4] = _.sumBy(data, 'totalAmount').toLocaleString('en');
            return sums;
        },
        onEditDrawRequest(data) {
            this.$emit('open', { type: 'edit-draw-request', drawdown: this.data });
        },
        onAddReturn(data) {
            this.$emit('open', { type: 'add-return', data });
        },
        onEditReturn(returnData) {
            this.$emit('open', { type: 'edit-return', data: returnData, drawdown: this.data });
        },
        isReserve(date) {
            return date > +new Date();
        },
        onOpen() {
            if (this.sno) this.fetchData();
            else {
                const AMT = this.drawdown?.amount || 0;
                this.form.principalAmount = AMT - _.sumBy(this.drawdown?.repaymentList, 'principalAmount');
            }
        },
        onClose(refresh) {
            this.$emit('close', refresh || this.isReturnDeleted);
            this.isReturnDeleted = false;
        },
        getTotalRealRePayedAmt() {
            if (this.data) {
                const NON_RESERVE_LIST = _.filter(this.data.repaymentList, (o) => o.repaymentDate <= +new Date());
                return _.sumBy(NON_RESERVE_LIST, 'principalAmount');
            }
            return 0;
        },
        getPercentage() {
            if (this.data) return Math.round(((this.getTotalRealRePayedAmt() / this.data.amount) * 1000) / 10);
            return 0;
        },
        async fetchData() {
            const resp = await this.$api({
                method: 'GET',
                url: 'LoanReceipt/GetLoanReceiptDrawdownDetail',
                params: { sno: this.sno },
            });
            console.log('draw detail', resp);
            this.data = resp.data.detail;

            // 增加自動計算的借款餘額欄位
            let sum = 0;
            for (let i = 0; i < this.data.repaymentList.length; i += 1) {
                sum += this.data.repaymentList[i].principalAmount;
                this.data.repaymentList[i].balance = this.data.amount - sum;
            }
        },
        onFetchFullAmt() {
            this.form.principalAmount = this.drawdown?.amount;
            this.getTotalAmt();
        },
        getTotalAmt() {
            this.form.totalAmount = this.form.principalAmount + this.form.interestAmount;
        },

        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    try {
                        this.isLoading = true;
                        if (this.sno) await this.onUpdate();
                        else await this.onCreate();

                        this.$message({
                            showClose: true,
                            message: `已成功${this.sno ? '更新' : '建立'}還款`,
                            type: 'success',
                        });

                        this.onClose(true);
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },
        async onCreate() {
            await this.$api({
                method: 'POST',
                url: 'LoanReceipt/AddLoanReceiptRepayment',
                data: { ...this.form, loanReceiptDrawdownSno: this.drawdown?.sno },
            });
        },
        async onUpdate() {
            await this.$api({
                method: 'POST',
                url: 'LoanReceipt/UpdateLoanReceiptRepayment',
                data: { ...this.form, loanReceiptDrawdownSno: this.drawdown?.sno },
            });
        },
        async onDelete() {
            try {
                await this.$confirm('確定要刪除此動撥？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isLoading = true;
                await this.$api({
                    method: 'POST',
                    url: 'LoanReceipt/DeleteLoanReceiptDrawdown',
                    data: { sno: this.sno },
                });

                this.$message({
                    showClose: true,
                    message: '已成功刪除動撥',
                    type: 'success',
                });
                this.onClose(true);
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        async onDeleteReturn(sno) {
            try {
                await this.$confirm('確定要刪除此還款？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });

                this.isLoading = true;
                await this.$api({
                    method: 'POST',
                    url: 'LoanReceipt/DeleteLoanReceiptRepayment',
                    data: { sno },
                });

                this.$message({
                    showClose: true,
                    message: '已成功刪除還款',
                    type: 'success',
                });
                this.fetchData();
                this.isReturnDeleted = true;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },
        onRepaymentDropdownClick(cmd) {
            if (cmd.action === 'edit') {
                this.onEditReturn(cmd.repayment);
            }
            if (cmd.action === 'delete') {
                this.onDeleteReturn(cmd.repayment.sno);
            }
        },
        disabledDate(date) {
            if (this.drawdown?.repaymentWay === 1) {
                return moment(date).isBefore(moment(this.drawdown?.drawdownDate)) || moment(date).isAfter(moment(this.contrast.repaymentEndDate));
            }
            return moment(date).isBefore(moment(this.drawdown?.drawdownDate)) || moment(date).isAfter(moment(this.contrast.amortizationEndDate));
        },
        onAutoFillDate() {
            if (this.form.reM_FEE_AMT) this.form.reM_FEE_PAY_DAT = this.form.repaymentDate;
            else {
                this.form.reM_FEE_PAY_DAT = null;
                this.form.reM_FEE_BNK_SNO = null;
            }
        },
    },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.loan-draw-dialog {

   .el-dialog {
     max-width: 1150px;
   }

    .reserved {
        display: inline-block;
        color: #e88f0a;
        background-color: #faf0e0;
        padding: 1px 5px;
        margin-left: 8px;
        border-radius: 4px;
        font-size: 9pt;
    }
}
</style>
